/* Dashboard Builder — shared types. */
export type TileChart =
  | 'donut' | 'pie' | 'bar' | 'hbar' | 'stacked'
  | 'scatter' | 'table' | 'number' | 'list' | 'map';

export type AggChart =
  | 'bar' | 'stacked' | 'line' | 'area' | 'pie' | 'donut' | 'scatter' | 'table' | 'number';

export interface CustomQuery {
  chart: AggChart;
  dimension?: string;
  measure: string;
  series?: string;
  x_measure?: string;
  y_measure?: string;
  template_ids?: string[];
  limit?: number;
  sort?: 'value_desc' | 'label_asc';
}

export type DashPage = 'dashboard' | 'analytics';
export type LayoutScope = 'shared' | 'personal';

export interface TileInstance {
  i: string;          // unique grid id
  type: string;       // catalog key
  title: string;
  chart?: TileChart;  // selected chart variant (where the tile supports more than one)
  metric?: string;    // for the single-KPI tile
  query?: CustomQuery; // for the 'custom' tile type
  x: number; y: number; w: number; h: number;
}

export interface BandColors {
  Low: string; Medium: string; High: string; Critical: string; accent: string;
}

export const DEFAULT_COLORS: BandColors = {
  Low: '#10B981', Medium: '#F59E0B', High: '#EF4444', Critical: '#7F1D1D', accent: '#0D63FF',
};

export interface SavedLayout {
  tiles: TileInstance[];
  colors: Partial<BandColors>;
  scope?: LayoutScope;
  updated_at?: string;
}

export interface DashFilters {
  broker_id?: string; client_id?: string; site_id?: string;
  template_id?: string; from?: string; to?: string;
}

export interface Preset {
  id: string;
  page: DashPage;
  name: string;
  scope: LayoutScope;
  owner_id: string | null;
  is_mine: boolean;
  can_edit: boolean;
  tiles: TileInstance[];
  colors: Partial<BandColors>;
  updated_at?: string;
}

export interface PresetsResponse {
  presets: Preset[];
  user_default_preset_id: string | null;
  tenant_default_preset_id: string | null;
  can_edit_shared: boolean;
  can_set_tenant_default: boolean;
}

export interface LayoutResponse {
  exists: boolean;
  effective_scope: LayoutScope | null;
  has_shared: boolean;
  has_personal: boolean;
  can_edit_shared: boolean;
  layout: SavedLayout | null;
  shared: SavedLayout | null;
}
